/* =====================================================================
   BeezFy — Video nella gallery della SCHEDA PRODOTTO
   ---------------------------------------------------------------------
   L'autoplay non è l'attributo `autoplay`: quello farebbe partire (e
   scaricare) il video anche se la slide è nascosta o la gallery è fuori
   schermo. Qui parte solo quando la slide è ATTIVA e la gallery è
   davvero a schermo, e si ferma appena una delle due condizioni cade.

   I <video> hanno preload="none": finché non si preme play (o non scatta
   l'autoplay) non si scarica un byte.

   ⚠️ Lo scrubber cambia prodotto SENZA ricaricare la pagina: rifà da capo
   l'HTML della sezione (beezfy-product-scrubber.js → swapTo). La gallery
   vecchia sparisce dal documento e con lei gli osservatori. Per questo qui
   non si aggancia una volta sola: ogni gallery ha i suoi osservatori, che
   vengono ri-agganciati sul nuovo DOM e buttati via su quello vecchio.

   Doc: docs/VIDEO-IN-EVIDENZA.md
   ===================================================================== */
(function () {
  'use strict';

  var GALLERY_SEL = '[data-gallery-main], .beezfy-gallery';

  function autoplayAllowed() {
    try {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
      var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (c) {
        if (c.saveData) return false;
        if (/(^|-)2g$/.test(c.effectiveType || '')) return false;
      }
    } catch (e) { /* in dubbio, si procede */ }
    return true;
  }

  var allow = autoplayAllowed();
  var galleries = [];          // { el, inView, io, mo }
  var bound = new WeakSet();
  var videoBound = new WeakSet();

  function isActive(v) {
    var s = v.closest ? v.closest('.beezfy-gallery__media') : null;
    return !!(s && s.classList.contains('active'));
  }

  // ---- Comandi del player
  // Un video che parte da solo è un media della gallery, non un filmato da
  // guardare: i bottoni non devono comparire mai, nemmeno per un istante.
  // Per questo con l'autoplay acceso `controls` NON è nell'HTML (metterlo e
  // toglierlo via JS darebbe comunque il lampo dei bottoni che spariscono).
  // Li rimette il JS, e solo quando servono davvero: autoplay non consentito,
  // play negato dal browser, o video finito senza ripetizione — altrimenti
  // resterebbe un poster fermo senza modo di farlo partire.
  function hideControls(v) { v.removeAttribute('controls'); }
  function showControls(v) { v.setAttribute('controls', ''); }

  function bindVideo(v) {
    if (videoBound.has(v)) return;
    videoBound.add(v);

    if (!allow && v.hasAttribute('data-autoplay')) showControls(v);

    // Senza bottoni serve comunque un modo per fermarlo: basta toccarlo.
    v.addEventListener('click', function () {
      if (v.hasAttribute('controls')) return;      // ci pensano i comandi nativi
      if (v.paused) {
        delete v.dataset.userPaused;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        v.dataset.userPaused = '1';
        try { v.pause(); } catch (e) {}
      }
    });

    // Finito e senza ripetizione: senza comandi non si potrebbe rivedere.
    v.addEventListener('ended', function () { if (!v.loop) showControls(v); });
  }

  function sync(g) {
    if (!g || !g.el.isConnected) return;
    Array.prototype.forEach.call(g.el.querySelectorAll('[data-gallery-video]'), function (v) {
      bindVideo(v);
      var wants = allow && g.inView && isActive(v) && v.hasAttribute('data-autoplay')
                  && !document.hidden && !v.dataset.userPaused;

      if (!wants) {
        if (!v.paused) { try { v.pause(); } catch (e) {} }
        return;
      }
      if (!v.paused) return;

      // HLS quando il browser lo suona nativamente: banda adattiva, parte basso
      if (!v.getAttribute('src')) return;
      var hls = v.getAttribute('data-video-hls');
      if (hls && !v.dataset.hlsApplied && v.canPlayType && v.canPlayType('application/vnd.apple.mpegurl')) {
        v.dataset.hlsApplied = '1';
        v.src = hls;
      }
      v.muted = true;                       // l'autoplay senza muto viene negato
      hideControls(v);
      var p = v.play();
      if (p && p.catch) p.catch(function () { showControls(v); });   // negato: resta il poster e i comandi per farlo partire
    });
  }

  function syncAll() { galleries.forEach(sync); }

  function unbind(g) {
    if (g.io) { try { g.io.disconnect(); } catch (e) {} }
    if (g.mo) { try { g.mo.disconnect(); } catch (e) {} }
  }

  function bind(el) {
    if (bound.has(el)) return;
    if (!el.querySelector('[data-gallery-video]')) return;   // niente video: niente da osservare
    bound.add(el);

    var g = { el: el, inView: false, io: null, mo: null };
    galleries.push(g);

    if ('IntersectionObserver' in window) {
      g.io = new IntersectionObserver(function (entries) {
        g.inView = entries.some(function (e) { return e.isIntersecting && e.intersectionRatio >= 0.4; });
        sync(g);
      }, { threshold: [0, 0.4, 0.8] });
      g.io.observe(el);
    } else {
      g.inView = true;
    }

    // La gallery cambia slide togliendo/mettendo la classe .active sulle slide:
    // la osservo invece di dipendere da un evento che il componente non emette.
    if (window.MutationObserver) {
      g.mo = new MutationObserver(function () { sync(g); });
      g.mo.observe(el, { attributes: true, attributeFilter: ['class'], subtree: true });
    }

    sync(g);
  }

  // Butta via le gallery non più nel documento (swap dello scrubber) e aggancia
  // quelle nuove. Rieseguibile a costo quasi zero.
  function scan() {
    for (var i = galleries.length - 1; i >= 0; i--) {
      if (!galleries[i].el.isConnected) { unbind(galleries[i]); galleries.splice(i, 1); }
    }
    Array.prototype.forEach.call(document.querySelectorAll(GALLERY_SEL), bind);
  }

  function init() {
    scan();

    document.addEventListener('visibilitychange', syncAll);
    // ritorno dal tasto Indietro (pagina ripresa dalla cache del browser)
    window.addEventListener('pageshow', syncAll);

    // Cambio prodotto dallo scrubber: la sezione viene rigenerata e poi annunciata.
    document.addEventListener('shopify:section:load', scan);
    // Rete di sicurezza per gli altri percorsi che rifanno la gallery senza annunciarla.
    document.addEventListener('variant:changed', scan);

    if (window.MutationObserver) {
      var pending = false;
      new MutationObserver(function (muts) {
        if (pending) return;
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) {
            pending = true;
            requestAnimationFrame(function () { pending = false; scan(); });
            return;
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
